
import { defineComponent } from 'vue';
import { defineRule, Form } from 'vee-validate';
import { useProfileStore } from '../../store/profileStore';
import { useMainStore } from '@/store/mainStore';
import AppInput from '@/components/UI/AppInput.vue';
import AppSelect from '@/components/UI/AppSelect.vue';
import ValidationService from '@/services/ValidationService';

defineRule('email', (value: string) => ValidationService.isEmail(value) || !value || 'Email is not valid');
defineRule('phone', (value: string) => ValidationService.isPhone(value) || !value || 'Phone is not valid');
defineRule('zipCode', (value: string) => ValidationService.isZipCode(value) || !value || 'ZIP Code is not valid');

export default defineComponent({
  components: {
    Form,
    AppInput,
    AppSelect,
  },
  setup() {
    const profileStore = useProfileStore();
    const mainStore = useMainStore();

    const schema = {
      email: 'email',
      phone: 'phone',
      zipCode: 'zipCode',
    };

    return {
      profileStore,
      mainStore,
      schema,
    };
  },
});
